export default {
    "pricing.hero.title": "Choose the plan that fits you",
    "pricing.hero.description": "Access the best preparation platform for the Canadian citizenship exam. Simple, effective, and guaranteed.",
    "pricing.promo.banner": "February Month of Love Special! 💝 Enjoy a 30% discount on all our plans.",
    "pricing.promo.code_label": "Use code: LOVE30",

    "pricing.plans.free.name": "Free",
    "pricing.plans.free.subtitle": "Try CitoyenPro",
    "pricing.plans.free.description": "Start your preparation and discover our learning tools.",
    "pricing.plans.free.feature1": "Dark mode included",
    "pricing.plans.free.feature2": "Limited to 10 questions/quiz",
    "pricing.plans.free.feature3": "Basic statistics",
    "pricing.plans.free.feature4": "Limited access to themes",
    "pricing.plans.free.feature5": "Minimal advertising",
    "pricing.plans.free.feature6": "📖 Discover Canada Book (EPUB)",
    "pricing.plans.free.accroche": "Ideal for testing the app before committing.",
    "pricing.plans.free.cta": "Start Now",

    "pricing.plans.standard.name": "Standard",
    "pricing.plans.standard.subtitle": "Most Popular",
    "pricing.plans.standard.description": "Everything you need to master the guide and pass the exam.",
    "pricing.plans.standard.feature1": "All themes unlocked",
    "pricing.plans.standard.feature2": "Unlimited Quizzes",
    "pricing.plans.standard.feature3": "Unlimited Flashcards",
    "pricing.plans.standard.feature4": "Advanced statistics",
    "pricing.plans.standard.feature5": "Zero advertising",
    "pricing.plans.standard.feature6": "Multi-platform access",
    "pricing.plans.standard.feature7": "📖 Discover Canada Book (EPUB)",
    "pricing.plans.standard.accroche": "The ideal plan for complete and effective preparation.",
    "pricing.plans.standard.cta": "Choose Standard",

    "pricing.plans.premium.name": "Premium",
    "pricing.plans.premium.subtitle": "The Full Experience",
    "pricing.plans.premium.description": "The ultimate learning experience with all our exclusive tools.",
    "pricing.plans.premium.feature1": "Everything in Standard",
    "pricing.plans.premium.feature2": "Unlimited Mock Exams",
    "pricing.plans.premium.feature3": "Full Audio Summaries",
    "pricing.plans.premium.feature4": "24/7 Priority Support",
    "pricing.plans.premium.feature5": "Early access to new features",
    "pricing.plans.premium.feature6": "Satisfaction guarantee",
    "pricing.plans.premium.feature7": "📖 Discover Canada Book (EPUB)",
    "pricing.plans.premium.accroche": "For those who want to leave nothing to chance and maximize their success.",
    "pricing.plans.premium.cta": "Go Premium",

    "pricing.status.per_month": "/ month",
    "pricing.status.tax_included": "Tax included",
    "pricing.status.loading": "Loading...",
    "pricing.status.current": "Your current plan",
    "pricing.status.manage": "Manage my plan",
    "pricing.status.upgrade_premium": "Upgrade to Premium",
    "pricing.status.downgrade_standard": "Downgrade to Standard",

    "pricing.faq.title": "Frequently Asked Questions",
    "pricing.faq.q1": "Can I cancel my subscription at any time?",
    "pricing.faq.a1": "Yes, absolutely. CitoyenPro has no commitment. You can cancel your subscription with one click from your settings. You will keep premium access until the end of your billing period.",
    "pricing.faq.q2": "What is the difference between Standard and Premium?",
    "pricing.faq.a2": "The Standard plan unlocks all content (themes, quizzes, flashcards). The Premium plan adds mock exams (timed like the official one) and audio summaries to learn without a screen. The Discover Canada book in EPUB format is included for free in all plans.",
    "pricing.faq.q3": "Are the questions up to date?",
    "pricing.faq.a3": "Yes, our team updates the database as soon as a change is made to the official 'Discover Canada' guide.",
    "pricing.faq.q4": "Can I use CitoyenPro on multiple devices?",
    "pricing.faq.a4": "Of course! Your account is synced across your computer, tablet, and phone. You can pick up your study right where you left off.",
    "pricing.faq.q5": "What payment methods are accepted?",
    "pricing.faq.a5": "We use Stripe to secure transactions. We accept all major credit cards (Visa, Mastercard, Amex) as well as Apple Pay and Google Pay."
};
